import { ActionIcon, Card, Group, Stack } from '@mantine/core';
import type { CeleryQueue, CeleryTask } from '@repo/api-codegen';
import { Icon, Text, Title } from '@repo/foundations';
import { useStyles } from '../InspectCeleryPage.styles';
import { TaskCard } from './TaskCard';

interface QueueCardProps {
	queue: CeleryQueue;
	tasks: CeleryTask[];
	onQueueClick: () => void;
	onTaskClick: (task: CeleryTask) => void;
}

export function QueueCard({
	queue,
	tasks,
	onQueueClick,
	onTaskClick,
}: QueueCardProps) {
	const { classes, theme } = useStyles();

	return (
		<Card
			className={classes.card}
			bg={theme.other.getColor('surface/primary/default')}
		>
			<Stack spacing="md">
				<Group position="apart">
					<Group spacing="xs">
						<Icon name="list" color="icon/primary/default" size="md" />
						<Title size="md" weight="semibold" color="text/primary/default">
							{queue.name}
						</Title>
					</Group>
					<Group spacing="xs">
						<Text size="sm" color="text/secondary/default">
							{tasks.length} task(s)
						</Text>
						<ActionIcon variant="outline" size="sm" onClick={onQueueClick}>
							<Icon name="dots" />
						</ActionIcon>
					</Group>
				</Group>

				<Stack spacing="xs">
					<Group spacing="lg">
						<Text size="sm" color="text/secondary/default">
							Workers: {queue.workers.join(', ')}
						</Text>
						<Text size="sm" color="text/secondary/default">
							Durable: {queue.durable ? 'Yes' : 'No'}
						</Text>
					</Group>
				</Stack>

				{tasks.length > 0 ? (
					<Group spacing="xs" align="flex-start">
						{tasks.map((task) => (
							<TaskCard
								key={`${task.worker_name}-${queue.name}-${task.id}`}
								task={task}
								onClick={() => onTaskClick(task)}
							/>
						))}
					</Group>
				) : (
					<Text size="sm" color="text/secondary/default">
						No tasks are currently running.
					</Text>
				)}
			</Stack>
		</Card>
	);
}
